
var wpVars

const inputHandler = (masks, max, event) => {
    let c = event.target;
    let v = c.value.replace(/\D/g, '');
    let m = c.value.length > max ? 1 : 0;
    VMasker(c).unMask();
    VMasker(c).maskPattern(masks[m]);
    c.value = VMasker.toPattern(v, masks[m]);
}

function init() {
    wpVars = JSON.parse(hoist)
    
    // Header Class
    const header = new Header();
    window.header = header;

    // Carousels
    carouselInstancing();

    // phone cta 
    let CTA = new PhoneCTA();

    // sendMail
    sendMail()

    var telMask = ['(99) 9999-99999', '(99) 99999-9999']
    var phones = document.querySelectorAll('input[name="Telefone"]')
    if (phones.length > 0) {
        phones.forEach(phone => {
            VMasker(phone).maskPattern(telMask[0])
            phone.addEventListener('input', inputHandler.bind(undefined, telMask, 14), false)
        })
    }

    let anchors = document.querySelectorAll('.is-anchor');

    anchors.forEach(anchor => {
        anchor.addEventListener('click', handleAnchors);
    })

    setTimeout(() => {
        if (!getCookie('cookies')) {
            $('.cookie-warning').fadeIn();
        } else {
            document.body.classList.add('cookies-accepted');
        }
    }, 600);

    $('.cookie-warning button').on('click', () => {
        setCookie('cookies', 'user accepted cookies', 30);
        document.body.classList.add('cookies-accepted');
    })

    loadMoreMedias()

    let observer = lozad()
    observer.observe()
}

// window load binds
window.onload = init;

const DOMLoaded = () => {
    // these are not always necessary but sometimes they fuck with ya
    if (helpers.iOS) {
        document.querySelector('html').classList.add('ios');
    } else if (helpers.IE()) {
        document.querySelector('html').classList.add('ie');
    }
}

// domcontent binds
document.addEventListener('DOMContentLoaded', DOMLoaded);